import {AgGridReact} from "ag-grid-react";
import AgGridUtils from "../../../../../../utils/aggrid-utils.js";
import {useMemo, useState} from "react";
import PrintableTableAgGrid from "../../../../../../components/printable-table/printable-table-ag-grid.jsx";

export default function LinkedTable({ title, data }) {
    const linked = data?.attendance?.linked ?? [];
    const [gridApi, setGridApi] = useState(null);

    const columnDefs = useMemo(() => ([
        { headerName: "Protocolo", field: "attendance_protocol", flex: 1 },
        { headerName: "Inicio", field: "attendance_start", flex: 1 },
        { headerName: "Fim", field: "attendance_end", flex: 1 },
    ]), [linked])

    return (
        <div className="space-y-4 px-5">
            <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f]">
                {title}
            </h2>
            <div className="w-full print:hidden">
                <AgGridReact
                    rowData={linked ?? []}
                    columnDefs={columnDefs}
                    defaultColDef={{ resizable: false }}
                    animateRows={false}
                    suppressCellFocus={true}
                    gridOptions={{ localeText: AgGridUtils.localization() }}
                    theme={AgGridUtils.generalTheme({ headerTextColor: "#676a6c" })}
                    domLayout="autoHeight"
                    onGridReady={(params) => setGridApi(params.api)}
                />
            </div>
            <div className="hidden print:block rounded-[8px] overflow-hidden border border-[#e0e1e3]">
                <PrintableTableAgGrid
                    gridApi={gridApi}
                    className="!border-0 w-full -my-px"
                    thClassName="first:!border-l-0 last:!border-r-0 text-[#676a6c]"
                    tdClassName="first:!border-l-0 last:!border-r-0"
                />
            </div>
        </div>
    )
}